import { previewColumns } from "./playerColumns";

/* THE PHONE'S SET TABLE, AS THE EXERCISE BUILDER PREVIEWS IT — W72 step 3 (his note, 2026-09-25: *"the on the
 * client's phone in the exercise builder will be not of the workout overview but inside when he's actually
 * training. ok with no logged numbers but '-' maybe instead"*).
 *
 * ⚠️ PORTED, NEVER DRAWN FRESH: the COLUMNS and their ORDER are the generated `playerColumns.ts` (executed from
 * `LoadFieldPolicy.previewColumns`), and every size below is `SetLogTable.swift`'s own, in phone POINTS — the
 * harness gate `w72-3-the-exercise-builder` parses each one out of the Swift and fails if this file disagrees.
 * W84 page 2 (2026-09-27): the phone's table became a card — the head in the hint ink at 0.7 tracking, the log ring
 * 26 pt (`W84SetMark.diameter`) in the hint ink, `Mark all` quiet in the secondary ink — and this preview follows.
 */
export const SET_TABLE = {
  setW: 34,
  restW: 52,
  tickW: 44,
  rowMinHeight: 60,
  headerSize: 11,
  headerTracking: 0.7,
  setLabelSize: 13,
  numberSize: 20,
  restSize: 13,
  tickSize: 26,
  markAllSize: 14,
} as const;

/** How many empty rows the preview draws — a library exercise has no sets of its own, so the number is ours. */
export const PREVIEW_ROWS = 3;

/** What an unlogged cell shows: `–` where a number goes (his word). W127: the band column (and its `—`) is gone. */
export const EMPTY_NUMBER = "–";

export type PreviewCell = { column: string; text: string };

/** The preview's rows: the phone's columns for these fields, `–` in every number, the set's own rank. */
export function previewTable(trackingFields: readonly string[]): { columns: readonly string[]; rows: PreviewCell[][] } {
  const columns = previewColumns(trackingFields);
  const rows = Array.from({ length: PREVIEW_ROWS }, (_, i) =>
    columns.map((column) => ({
      column,
      text: column === "SET" ? String(i + 1) : EMPTY_NUMBER,
    })));
  return { columns, rows };
}
